import { memo } from 'react'

import { OtherProducts } from 'modules/other-products'

import { homeRenovationMobileOtherProducts, homeRenovationOtherProducts } from './data'

export const HomeRenovationOtherProducts = memo(() => (
  <OtherProducts
    products={homeRenovationOtherProducts}
    mobileProducts={homeRenovationMobileOtherProducts}
    dataLayerAction="Empréstimo para reforma de casa"
  />
))

HomeRenovationOtherProducts.displayName = 'HomeRenovationOtherProducts'
